import { falconSiteSettingsSchema } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import * as z from "zod";

export const updateFalconSiteSettings = {
  name: "updateFalconSiteSettings" as const,
  input: z.object({ siteSettings: falconSiteSettingsSchema }),
  output: z.object({ success: z.boolean() }),
};
